/** Matomo-kampagneparametre for åbning via push-notifikation (query før `#`). */
export const PUSH_MTM_CAMPAIGN = "push";
export const PUSH_MTM_MEDIUM = "notification";
export const PUSH_MTM_SOURCE = "app";

const DEFAULT_PUSH_HASH_ROUTE = "/mine-dokumenter";

export function applyPushCampaignQueryParams(href: string): string {
    const url = new URL(href);
    url.searchParams.set("mtm_campaign", PUSH_MTM_CAMPAIGN);
    url.searchParams.set("mtm_medium", PUSH_MTM_MEDIUM);
    url.searchParams.set("mtm_source", PUSH_MTM_SOURCE);
    return url.toString();
}

export function applyPushCampaignToWindow(win: Pick<Window, "location" | "history">): void {
    const nextHref = applyPushCampaignQueryParams(win.location.href);
    win.history.replaceState(win.history.state, "", nextHref);
}

/** Hash-rute fra FCM `data.url` (`#/mine-dokumenter` → `/mine-dokumenter`). */
export function hashRouteFromNotificationUrl(url: unknown): string {
    if (typeof url !== "string" || url.trim() === "") {
        return DEFAULT_PUSH_HASH_ROUTE;
    }
    const trimmed = url.trim();
    const withoutHash = trimmed.startsWith("#") ? trimmed.slice(1) : trimmed;
    if (withoutHash.startsWith("/")) {
        return withoutHash.split("?")[0];
    }
    return `/${withoutHash.split("?")[0]}`;
}

export function notificationDataUrl(data: unknown): unknown {
    if (!data || typeof data !== "object") {
        return undefined;
    }
    return (data as { url?: unknown }).url;
}
